import assignSwellLetter from './swell-letters';

import swellPreview from 'components/swell-preview';
import Tooltip from 'components/tooltip/tooltip';
import SwellIcon from 'components/swell-icon/swell-icon';
import Units from 'utils/units'; // eslint-disable-line import/no-named-as-default
export default class SwellTooltip extends Tooltip {
  renderTooltip() {
    const data = JSON.parse(this.el.dataset.swellState);

    this.tooltip = document.createElement('div');
    this.tooltip.classList.add('tooltip-popup', 'not_in_print');

    const tooltipHeader = document.createElement('div');
    tooltipHeader.classList.add('tooltip-popup__header');
    this.tooltip.appendChild(tooltipHeader);
    tooltipHeader.innerText = this.el.dataset.date;
    const content = document.createElement('div');
    const swell = document.createElement('div');
    content.appendChild(swell);

    const wind = JSON.parse(this.el.dataset.wind);
    wind.offshoreness = JSON.parse(this.el.dataset.windState);
    this.unmountSwellPreview = swellPreview(swell, data, wind);

    const table = document.createElement('table');
    const classname = 'tooltip-table';
    table.className = classname;
    content.appendChild(table);

    data.forEach((d, i) => {
      const iconRow = document.createElement('tr');
      const headerIconCell = document.createElement('th');
      const swellIndexSpan = document.createElement('span');
      swellIndexSpan.className = `${classname}__swell-index`;
      swellIndexSpan.appendChild(
        document.createTextNode(assignSwellLetter(i + 1))
      );
      headerIconCell.appendChild(swellIndexSpan);
      headerIconCell.appendChild(document.createTextNode(`Swell${i + 1} (`));
      const unitsSpan = document.createElement('span');
      unitsSpan.className = 'heightu';
      unitsSpan.innerText = 'm';
      headerIconCell.appendChild(unitsSpan);
      headerIconCell.appendChild(document.createTextNode(')\n& period'));

      const iconCell = document.createElement('tr');
      iconCell.className = `${classname}__icon-cell`;

      let iconEl = null;
      if (d) {
        const swellIcon = new SwellIcon({ units: Units });
        swellIcon.update(d);
        iconEl = swellIcon.el;
      } else {
        iconEl = document.createTextNode('—');
      }

      const svgCell = document.createElement('td');
      svgCell.appendChild(iconEl);
      iconCell.appendChild(svgCell);

      const dir = document.createElement('td');
      dir.innerText = d && d.letters ? d.letters : '';
      iconCell.appendChild(dir);

      const periodCell = document.createElement('td');
      periodCell.className = `${classname}__period-cell has-text-bold`;
      if (d && d.period) periodCell.innerText = `${d.period}s`;
      iconCell.appendChild(periodCell);

      iconRow.appendChild(headerIconCell);
      iconRow.appendChild(iconCell);

      table.appendChild(iconRow);
    });

    const description = document.createElement('div');
    description.className = 'tooltip-description';

    const firstItem = document.createElement('p');
    const firstTerm = document.createElement('span');
    firstTerm.className = 'highlight is-blue';
    firstTerm.innerText = 'Blue';

    const firstDescription = document.createTextNode(' - Waves producing surf');
    firstItem.appendChild(firstTerm);
    firstItem.appendChild(firstDescription);

    const secondItem = document.createElement('p');
    const secondTerm = document.createElement('span');
    secondTerm.className = 'highlight is-red';
    secondTerm.innerText = 'Red';

    const secondDescription = document.createTextNode(
      ' - Open sea waves that may not wrap into the surf break.'
    );

    secondItem.appendChild(secondTerm);
    secondItem.appendChild(secondDescription);

    description.appendChild(firstItem);
    description.appendChild(secondItem);

    content.appendChild(description);

    const tooltipBody = document.createElement('div');
    tooltipBody.classList.add('tooltip-popup__body');
    tooltipBody.classList.add('tooltip-popup__body--custom');
    tooltipBody.appendChild(content);
    this.tooltip.appendChild(tooltipBody);
    this.closeButton = document.createElement('div');
    this.closeButton.classList.add('tooltip-popup__close-button');
    this.tooltip.appendChild(this.closeButton);

    const { currentUnits } = window.unitsConv;
    if (currentUnits !== 'm') {
      window.unitsConv.switchSpans(currentUnits, this.tooltip);
    }
  }

  hide() {
    this.unmountSwellPreview();
    super.hide();
  }
}
